import CourseRun from "@/models/CourseRun";
import moment from "moment";

export default class User {
    constructor(raw = {}) {
        this.id = raw.id ?? "-1";
        this.name = raw.name ?? "";
        this.surname = raw.surname ?? "";
        this.username = raw.username ?? "";
        this.roles = raw.roles ?? [];
        this.email = raw.email ?? "";
        this.companyDepartments = raw.companyDepartments ?? [];
        this.isDataProtectionAccepted = raw.isDataProtectionAccepted ?? false;
        this.isActive = raw.isActive ?? false;
        this.companyId = raw.companyId ?? "";
        this.companyName = raw.companyName ?? "";
        this.courseRuns = raw.courseRuns ?? [];
        this.isHimself = raw.isHimself ?? false;
        this.birthdate = raw.birthdate ?? "";
        this.isAdmin = raw.isAdmin ?? false;
        this.isLiveCourseUser = raw.isLiveCourseUser ?? false;
        this.zvuExpirationDate = raw.zvuExpirationDate ?? "";
        this.courseRuns = raw.courseRuns ? raw.courseRuns.map(run => new CourseRun(run)) : [];

    }

    get isAdminOfCompany() {
        return this.roles.includes("app-admin");
    }

    isSuperAdmin() {
        return this.roles.includes("app-superadmin");
    }

    isAdminOrSuperAdmin() {
        return this.isAdminOfCompany || this.isSuperAdmin();
    }

    isUser() {
        return this.roles.includes("app-user");
    }

    get fullName() {
        return this.name + " " + this.surname;
    }

    get birthdateMoment() {
        return moment(this.birthdate);
    }

    get zvuMoment() {
        return moment(this.zvuExpirationDate);
    }

    isZvuPassed() {
        return this.zvuMoment.isValid() && this.zvuMoment.isAfter(moment.now())
    }

    isBirthdayValid() {
        return this.birthdateMoment.isValid();
    }

    isValid() {
        return this.name.length > 1 && this.surname.length > 1 && this.email.length > 4 && this.email.includes("@") && this.email.includes(".");
    }

    get latestCourseSyncTimestamp() {
        const timestamps = this.courseRuns
            .map((run) => run.latestSyncTimestamp)
            .filter((value) => value !== null);

        if (timestamps.length === 0) {
            return null;
        }

        return Math.max(...timestamps);
    }

    get latestCourseSyncLabel() {
        return this.latestCourseSyncTimestamp == null
            ? "Noch kein Kurs-Sync"
            : new Date(this.latestCourseSyncTimestamp).toLocaleString("de-DE");
    }

    get activeSyncEntries() {
        return this.courseRuns.flatMap((run) => run.activeSyncEntries);
    }

    get syncProblemEntries() {
        return this.activeSyncEntries.filter((entry) => entry.hasSyncRisk);
    }

    get hasCourseSyncRisk() {
        return this.syncProblemEntries.length > 0;
    }

    get courseSyncStatus() {
        if (this.activeSyncEntries.length === 0) {
            return "Keine aktiven Kurse";
        }

        if (this.syncProblemEntries.length === 0) {
            return "";
        }

        return this.syncProblemEntries.length === 1
            ? "1 aktiver Kurs mit Sync-Problem"
            : `${this.syncProblemEntries.length} aktive Kurse mit Sync-Problemen`;
    }
}
